import Dialog from "@components/dialog-root";
import ErrorBoundary from "@components/error-boundary";
import ScrollToTop from "@components/scroll-to-top";
import Toast from "@components/toast";
import { Outlet, useNavigate } from "react-router-dom";
import { setNavigate } from "./shared/utils/navigation";

const NavigationSetter: React.FC = () => {
  const navigate = useNavigate();
  setNavigate(navigate);
  return null;
};

const App = () => {
  return (
    <ErrorBoundary feature="app">
      <ScrollToTop />
      <NavigationSetter />
      <Outlet />
      <Toast />
      <Dialog />
    </ErrorBoundary>
  );
};

export default App;
